import { compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { noop } from 'lodash';

import { getDeletedBarbers } from '../actions';
import { restoreDeletedBarber as restoreDeletedShopBarber } from '../actions/shop';
import { restoreDeletedBrandBarber } from '../actions/brand';
import DeletedBarbersList from './DeletedBarbersList';
import { getAllDeleted } from '../selector';
import confirmModal from '../../../common/confirmModal';
import withOwnerTypeAndId from '../../../common/hoc/withOwnerTypeAndId';
import { isBrandViewActive } from '../../../auth/selectors';
import withLoadingList from '../../../common/hoc/withLoaingList';
import EmptyList from './EmptyList';
import { withActionByRole } from '../../../common/helpers/actions';
import { t } from '../../../../modules/infra/i18n';

const mapStateToProps = state => ({
  barbers: getAllDeleted(state),
  isBrandView: isBrandViewActive(state),
  shop: state.auth.shop,
});

const mapDispatchToProps = { getDeletedBarbers };

export default compose(
  withOwnerTypeAndId,
  connect(mapStateToProps, mapDispatchToProps),
  withActionByRole('restoreDeletedBarber', restoreDeletedShopBarber, noop, restoreDeletedBrandBarber),
  withHandlers({
    onRestore: props => async (barberId) => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('barber:deleted_barbers.restore_modal.title'),
        message: t('barber:deleted_barbers.restore_modal.message'),
      });

      if (!confirmed) {
        return false;
      }
      return props.restoreDeletedBarber(barberId, props.shop);
    },
    getAllDeletedBarbers: props => () => props.getDeletedBarbers(props.ownerId, props.ownerType),
  }),
  lifecycle({
    componentDidMount() {
      this.props.getAllDeletedBarbers();
    },
  }),
  withLoadingList(
    props => props.barbers,
    EmptyList,
  )
)(DeletedBarbersList);
